export const GUIDE_SECTIONS = [
    {
        id: 'vision',
        label: 'Vision',
        title: 'Precision Inventory',
        content: `
### The Automatic Pantry
Cathy's Sous Chef uses advanced scanning to track your inventory.
- **Scan Groceries:** Tap the camera icon and take a photo of your grocery haul. The Chef identifies items and adds them to your "Kitchen" stock.
- **Privacy First:** Photos are processed momentarily to identify ingredients and then **immediately deleted**. Your images are never saved.
- **Natural Updates:** You can simply type *"I bought 3 cartons of eggs and used the milk"* to update your stock without manual data entry.
- **Draft & Review:** Scans go into a "Draft" area first. You can tap to edit any mistakes before confirming them into your inventory.
    `
    },
    {
        id: 'creation',
        label: 'Creation',
        title: 'Chef-Grade Planning',
        content: `
### Macro-Perfect Meals
Cathy's Sous Chef isn't just a recipe generator; it's a **precision culinary expert**.
- **The Process:** Type a command like *"Plan 3 days of high-protein dinners"*. The Chef selects recipes that use your *existing* ingredients while hitting your exact protein targets.
- **Regenerate:** Don't like a suggestion? You have limited "Regens" to request a new option for that specific slot.
- **Commit:** Once you're happy, **Commit** to the plan. This locks the menu and automatically deducts the ingredients from your virtual pantry.
    `
    },
    {
        id: 'preferences',
        label: 'Preferences',
        title: 'Intelligence Layers',
        content: `
### Customize the Brain
In the **Preferences** tab, you control the logic engine.
- **Intelligence Layers:** Toggle specific capabilities on/off.
    - **Pantry Intelligence:** Forces the Chef to prioritize ingredients you already own.
    - **Macro Enforcement:** Strictly adheres to your daily calorie/macro limits.
    - **Wine Sommelier:** Enables pairing suggestions.
- **Dietary Exclusions:** Permanently ban ingredients (e.g., "No Cilantro") from all future suggestions.
- **Meal Chips:** Configure which meals (Breakfast, Lunch, Snack, Dinner) you want the Chef to plan for.
    `
    },
    {
        id: 'sommelier',
        label: 'Sommelier',
        title: 'Digital Cellar',
        content: `
### Curated Pairings
Manage your wine collection in the **Cellar** tab.
- **Add Bottles:** Use the **Scan Label** feature to instantly digitize a bottle, or add it manually.
- **The Pairing:** When the **Sommelier Layer** is active, the Sommelier will recommend the *exact bottle* from your cellar that best matches the flavor profile of your dinner.
- **Notes:** The Sommelier extracts and saves tasting notes for every bottle you scan.
    `
    },
    {
        id: 'power',
        label: 'Power User',
        title: 'Natural Language',
        content: `
### Talk to Cathy's Sous Chef
The command bar understands complex, natural instructions. Try these:
- *"I have some leftover chicken and rice, what can I make?"*
- *"Plan a vegan menu for the weekend, under 1800 calories."*
- *"I'm fasting for breakfast today, just plan lunch and dinner."*
- *"Add 5lbs of chicken breast to my pantry."*
    `
    }
];
